module.exports = __webpack_public_path__ + "static/envato-elements-85f943b625d3400029ffcd9421aa880a.svg";